import { useMemo } from 'react';
import { isNullish } from 'remeda';
import { FormField } from 'src/components';
import { usePartnersOptions } from 'src/graphql';

const commonProps = {
  textFieldProps: {
    variant: 'outlined',
    size: 'small',
    inputProps: {
      sx: {
        fontSize: '0.875rem',
      },
    },
  },
};

export function useNewClientForm(partnerId?: number | null) {
  const partnerOptions = usePartnersOptions();

  const newClientFormFields = useMemo(() => {
    const fields = [
      {
        ...commonProps,
        group: {
          title: 'Info',
          icon: 'person',
        },
        type: 'textfield',
        name: 'firstName' as const,
        required: 'First name is required',
        textFieldProps: {
          ...commonProps.textFieldProps,
          placeholder: 'First Name',
          autoFocus: !isNullish(partnerId),
        },
      },
      {
        ...commonProps,
        type: 'textfield',
        name: 'lastName' as const,
        required: 'Last name is required',
        textFieldProps: {
          ...commonProps.textFieldProps,
          placeholder: 'Last Name',
        },
      },
      {
        group: {
          title: 'Notes',
          icon: 'sticky_note_2',
        },
        placeholder: `What is the client’s comfort with technology?

Is there anything that should be known about the client when engaging in a support event?`,
        className: 'small',
        type: 'rich-text-bubble',
        name: 'notes' as const,
      },
      {
        type: 'switch',
        name: 'marketingOptOut' as const,
        label: 'Marketing Opt Out',
        defaultValue: false,
        labelSx: {
          ml: 0,
          alignSelf: 'flex-start',
          '& .MuiFormControlLabel-label': { fontSize: '0.875rem' },
        },
        group: {
          title: 'Preferences',
          icon: 'tune',
        },
        switchFieldProps: {
          size: 'small',
        },
      },
    ] as FormField[];

    if (isNullish(partnerId)) {
      fields.unshift({
        type: 'autocomplete',
        name: 'partner' as const,
        label: 'Partner',
        required: 'Partner is required',
        options: partnerOptions,
        blurOnSelect: false,
        textFieldProps: {
          variant: 'outlined',
          size: 'small',
          placeholder: 'Start typing partner',
          autoFocus: true,
        },
      });
    }

    return fields;
  }, [partnerOptions, partnerId]);

  return { newClientFormFields };
}
